import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';

import CircleIcon from './icons/circle_icon';

export default class MuteButton extends React.Component {
  constructor(props) {
    super(props);
    this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
  }
  render() {
    return (
      <CircleIcon viewBox="0 0 25 25" {...this.props}>
        <g id="iconMute">
          <path d="M9.472 14.152l1.054-1.135c-.33-1.025-.17-2.16-.17-2.16l-1.253-.02c-.077 2.084.13 2.702.13 2.702.065.227.148.427.24.612M15.057 10.858s.547 3.77-2.35 3.77c-.572 0-1.01-.15-1.343-.385l.498-.52c.22.164.5.277.847.277 1.292 0 1.61-1.41 1.623-1.492.004-.027.005-.614.005-1.368l3.222-3.364-.51-.533-2.714 2.833c0-.02-1.76 1.837-1.76 1.837l-5.076 5.3.51.532 2.383-2.488c.863.618 1.82.636 1.82.636v1.332h-1.88v1.193h4.747v-1.193H13.2v-1.332s2.298.048 2.98-2.354c0 0 .208-.62.13-2.704l-1.253.022zM14.334 9.105l-.004-1.4s-.094-1.455-1.622-1.455-1.628 1.486-1.628 1.486v4.722l.034.118 3.22-3.47z" />
        </g>
      </CircleIcon>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/phone_controls/buttons/mute_button.jsx